import React, { useCallback } from 'react';

import Dropdown from './Dropdown';
import FacebookButton from '../../FacebookButton';
import { useAuthSelector, useAuthService } from '~/theseus/containers/Auth';

import {
  usePagesQuery,
  useAccountsQuery,
  usePageQuery,
  useAccountQuery,
} from '~/theseus/hooks/queries';

const AccountSwitcher = () => {
  const { send: sendAuthService } = useAuthService();
  const isLoggedIn = useAuthSelector(state => state.matches('loggedIn'));

  const [accountId, setAccountId] = useAccountQuery();
  const [pageId, setPageId] = usePageQuery();

  const displayName = useAuthSelector(state => `${state.context.rgUser?.rg_info?.first_name} ${state.context.rgUser?.rg_info?.last_name}`);

  const { data: pages } = usePagesQuery({
    select: (data) => data.map(({ id, name }) => ({ id, name })),
    onSuccess: (data) => {
      // If user has page selected that is not apart of pages, then we need to
      // reset their page to the first page retrived by fb
      const userHasNoPageSelected = !pageId && data?.length > 0;
      const userHasInvalidPageSelected = !data?.find(({ id }) => pageId === id);

      if (userHasNoPageSelected || userHasInvalidPageSelected) {
        setPageId(data?.[0]?.id);
      }
    },
  });

  const { data: accounts } = useAccountsQuery({
    onSuccess: (data) => {
      // See above for pages
      const userHasNoAccountSelected = !accountId && data?.length > 0;
      const userHasInvalidAccountSelected = !data?.find(({ id }) => accountId === id);

      if (userHasNoAccountSelected || userHasInvalidAccountSelected) {
        setAccountId(data?.[0]?.id);
      }
    },
  });

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="user-display">
      <div className="user-display__row">
        <div className="user-display__name">
          { displayName }
        </div>
        <FacebookButton />
      </div>
      <div className="user-display__row">
        <Dropdown
          id="user_accounts"
          name="user_accounts"
          className="user_accounts"
          label="Account"
          options={accounts}
          value={accountId}
          onChange={setAccountId}
        />
        <Dropdown
          id="user_pages"
          name="user_pages"
          className="user_pages"
          label="Pages"
          options={pages}
          value={pageId}
          onChange={setPageId}
        />
      </div>
    </div>
  );
};

export default React.memo(AccountSwitcher);
